// Template272: Pekín - Día 3 p.1 (Dia3MurallaPekin.jsx)
// Hero Gran Muralla + sticker, intro, bloque Muralla China (img + SabiasQue), lista tramos (Mutianyu, Badaling), Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template272 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const title1 = page?.texts?.[3]?.content;
	const body1 = page?.texts?.[4]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const tramos = Array.isArray(page?.data?.tramos) ? page.data.tramos : [];
	const comoLlegar = page?.data?.comoLlegar;
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Hero */}
			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt="Gran Muralla"
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontSize: isSmallScreen ? 28 : 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								m: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt="sticker"
							sx={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: isSmallScreen ? 60 : -10,
								right: isSmallScreen ? "auto" : 0,
								left: isSmallScreen ? 25 : "auto",
							}}
						/>
					)}
				</Box>
			)}

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
						{intro}
					</Box>
				)}

				{/* Bloque Muralla China */}
				{(title1 || body1 || img1) && (
					<Box
						data-block-id="text-2"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 2,
							position: "relative",
						}}
					>
						<Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{title1 && (
									<Box
										component="h3"
										sx={{ ...estiloH3, marginTop: 1, marginBottom: 0.5 }}
									>
										{title1}
									</Box>
								)}
								{body1 && (
									<Box component="p" sx={estiloP}>
										{body1}
									</Box>
								)}
								{sabiasQue[0] && (
									<Box sx={{ position: "absolute", top: -10, left: "35%" }}>
										<SabiasQue
											icono={sabiasQue[0].icono}
											texto={sabiasQue[0].texto}
										/>
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				)}

				{/* Lista tramos */}
				{tramos.length > 0 && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 1,
							marginTop: 1.5,
						}}
					>
						{tramos.map((t) => (
							<Box
								key={t.nombre}
								sx={{
									backgroundColor: "#fff",
									borderRadius: "12px",
									padding: "12px 14px",
									border: "2px solid #e8e8e8",
								}}
							>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										flexWrap: "wrap",
										gap: 1,
										marginBottom: 1,
									}}
								>
									<Box component="h3" sx={estiloH3}>
										{t.nombre}
									</Box>
									<Box
										component="span"
										sx={{
											fontSize: 11,
											color: "#666",
											marginLeft: "auto",
											display: "flex",
											alignItems: "center",
											gap: 0.5,
										}}
									>
										⏱️ {t.tiempo} desde Pekín
									</Box>
								</Box>
								{t.desc && (
									<Box
										component="p"
										sx={{ ...estiloP, fontSize: 12, margin: 0 }}
									>
										{t.desc}
									</Box>
								)}
							</Box>
						))}
					</Box>
				)}

				{/* Cómo llegar */}
				{comoLlegar && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#fde1e0",
							border: "3px solid",
							borderColor: actualHeaderColor,
							borderRadius: "12px",
							padding: "8px",
							fontSize: 13,
							color: "#333",
							marginTop: 1.5,
							marginBottom: isSmallScreen ? 1.5 : 0,
						}}
					>
						<Box
							component="p"
							sx={{ paddingLeft: 1, margin: 0, lineHeight: 1.5 }}
						>
							{comoLlegar}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template272.thumbnail = "/images/template-1.png";
export default Template272;
